module.exports = __webpack_public_path__ + "img/Artboard 54.26fdae0f.png";